<script lang="ts">
	import { classes } from '@thearc-hq/ui-kit/utils';
	import DisclosureElement from '$lib/components/FAQ/DisclosureElement.svelte';

	export let content: Array<{
		headline: string;
		sublines: Array<{
			title: string;
			href: string;
		}>;
	}> = [];
	export let headline: string = '';
	let className: string | undefined;

	export { className as class };
</script>

<div
	class={classes('flex flex-col px-6 py-9 bg-accent-primary_005 rounded-lg space-y-8', className)}
>
	<p class="uppercase text-h-20">{headline}</p>
	{#each content as element}
		<DisclosureElement headline={element.headline} sublines={element.sublines} />
	{/each}
</div>
